import React from 'react';
import { ArrowUpRight } from 'lucide-react';

const TOOLS = [
  {
    id: 'calendar',
    name: 'Planting Calendar',
    description: 'See what to plant now, based on your frost date.',
    href: 'https://plant.bloomagrows.com',
    image: '/home/planting-calendar.jpg',
    imagePosition: 'object-top',
  },
  {
    id: 'layouts',
    name: 'Garden Layouts',
    description: 'Plan your beds, save a layout, and print it.',
    href: 'https://layout.bloomagrows.com',
    image: '/join/mock-beds.jpg',
    imagePosition: 'object-center',
  },
  {
    id: 'wtf',
    name: 'WTF is wrong with my plant?',
    description: 'Snap a photo and get a plan for what’s going on.',
    href: 'https://wtf.bloomagrows.com',
    image: '/wtf/og.jpg',
    imagePosition: 'object-center',
  },
] as const;

export default function HomeTools() {
  return (
    <section id="tools" className="py-4 bg-white scroll-mt-20">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-end gap-4 mb-4 md:mb-6">
          <div>
            <h2 className="text-xl md:text-2xl font-bold">Garden Tools</h2>
            <p className="text-gray-600 text-sm md:text-base mt-1 max-w-xl">
              Free tools to figure out when to plant, where it goes, and what’s
              going wrong.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-8">
          {TOOLS.map((tool) => (
            <a
              key={tool.id}
              href={tool.href}
              target="_blank"
              rel="noopener noreferrer"
              className="group relative h-40 md:h-64 overflow-hidden rounded-lg"
            >
              <img
                src={tool.image}
                alt=""
                className={`absolute inset-0 w-full h-full object-cover ${tool.imagePosition} transition-transform duration-300 group-hover:scale-105`}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/35 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-4 md:p-6">
                <h3 className="text-white text-lg md:text-xl font-semibold flex items-center gap-1.5">
                  {tool.name}
                  <ArrowUpRight className="h-4 w-4 shrink-0 opacity-80 group-hover:opacity-100" />
                </h3>
                <p className="text-gray-200 text-sm mt-1 line-clamp-2">
                  {tool.description}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
